export var SapAgentCommandKind;
(function (SapAgentCommandKind) {
    SapAgentCommandKind["SAP_AGENT_COMMAND_KIND_UPGRADE"] = "UPGRADE";
    SapAgentCommandKind["SAP_AGENT_COMMAND_KIND_ROLLBACK"] = "ROLLBACK";
    SapAgentCommandKind["SAP_AGENT_COMMAND_KIND_FETCH_LOGS"] = "FETCH_LOGS";
    SapAgentCommandKind["SAP_AGENT_COMMAND_KIND_ROTATE_CREDS"] = "ROTATE_CREDS";
    SapAgentCommandKind["SAP_AGENT_COMMAND_KIND_ROTATE_CERT"] = "ROTATE_CERT";
})(SapAgentCommandKind || (SapAgentCommandKind = {}));
